import { formatClientProposalDraft, parseClientProposalDraft } from "./clientProposal";

/** Read the freshest draft. The DOM may lead React during dictation/IME, but
 * must not overwrite a newer store update that has not rendered yet. */
export function workflowDraftSnapshot(
  latestRaw: string,
  renderedRaw: string,
  visibleValue?: string,
): { raw: string; visible: string } {
  const proposal = parseClientProposalDraft(latestRaw);
  const visible = proposal?.note ?? latestRaw;
  if (latestRaw !== renderedRaw || visibleValue === undefined || visibleValue === visible) {
    return { raw: latestRaw, visible };
  }
  return {
    raw: proposal ? formatClientProposalDraft(proposal.options, visibleValue) : visibleValue,
    visible: visibleValue,
  };
}

/** Append only: selection is intentionally irrelevant. No trim of user text. */
export function appendWorkflowDraft(
  latestRaw: string,
  renderedRaw: string,
  prompt: string,
  visibleValue?: string,
): string {
  if (!prompt.trim()) return latestRaw;
  const { raw } = workflowDraftSnapshot(latestRaw, renderedRaw, visibleValue);
  const separator = !raw || raw.endsWith("\n\n") ? "" : raw.endsWith("\n") ? "\n" : "\n\n";
  return raw + separator + prompt;
}
